export const Countries = [
  {
    name: "Afghanistan",
    code: "AF",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/5/5c/Flag_of_the_Taliban.svg",
  },
  {
    name: "\u00c5land Islands",
    code: "AX",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/5/52/Flag_of_%C3%85land.svg",
  },
  {
    name: "Albania",
    code: "AL",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/3/36/Flag_of_Albania.svg",
  },
  {
    name: "Algeria",
    code: "DZ",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/7/77/Flag_of_Algeria.svg",
  },
  {
    name: "American Samoa",
    code: "AS",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/8/87/Flag_of_American_Samoa.svg",
  },
  {
    name: "Andorra",
    code: "AD",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/1/19/Flag_of_Andorra.svg",
  },
  {
    name: "Angola",
    code: "AO",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/9/9d/Flag_of_Angola.svg",
  },
  {
    name: "Anguilla",
    code: "AI",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/b/b4/Flag_of_Anguilla.svg",
  },
  {
    name: "Antigua and Barbuda",
    code: "AG",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/8/89/Flag_of_Antigua_and_Barbuda.svg",
  },
  {
    name: "Argentina",
    code: "AR",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/1/1a/Flag_of_Argentina.svg",
  },
  {
    name: "Armenia",
    code: "AM",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/2/2f/Flag_of_Armenia.svg",
  },
  {
    name: "Aruba",
    code: "AW",
    file_url: "//upload.wikimedia.org/wikipedia/commons/f/f6/Flag_of_Aruba.svg",
  },
  {
    name: "Australia",
    code: "AU",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/8/88/Flag_of_Australia_%28converted%29.svg",
  },
  {
    name: "Austria",
    code: "AT",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/4/41/Flag_of_Austria.svg",
  },
  {
    name: "Azerbaijan",
    code: "AZ",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/d/dd/Flag_of_Azerbaijan.svg",
  },
  {
    name: "Bahamas",
    code: "BS",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/9/93/Flag_of_the_Bahamas.svg",
  },
  {
    name: "Bahrain",
    code: "BH",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/2/2c/Flag_of_Bahrain.svg",
  },
  {
    name: "Bangladesh",
    code: "BD",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/f/f9/Flag_of_Bangladesh.svg",
  },
  {
    name: "Barbados",
    code: "BB",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/e/ef/Flag_of_Barbados.svg",
  },
  {
    name: "Belarus",
    code: "BY",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/8/85/Flag_of_Belarus.svg",
  },
  {
    name: "Belgium",
    code: "BE",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/6/65/Flag_of_Belgium.svg",
  },
  {
    name: "Belize",
    code: "BZ",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/e/e7/Flag_of_Belize.svg",
  },
  {
    name: "Benin",
    code: "BJ",
    file_url: "//upload.wikimedia.org/wikipedia/commons/0/0a/Flag_of_Benin.svg",
  },
  {
    name: "Bermuda",
    code: "BM",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/b/bf/Flag_of_Bermuda.svg",
  },
  {
    name: "Bhutan",
    code: "BT",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/9/91/Flag_of_Bhutan.svg",
  },
  {
    name: "Bolivia (Plurinational State of)",
    code: "BO",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/b/b3/Bandera_de_Bolivia_%28Estado%29.svg",
  },
  {
    name: "Bonaire - Sint Eustatius and Saba",
    code: "BQ",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/2/20/Flag_of_the_Netherlands.svg",
  },
  {
    name: "Bosnia and Herzegovina",
    code: "BA",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/b/bf/Flag_of_Bosnia_and_Herzegovina.svg",
  },
  {
    name: "Botswana",
    code: "BW",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/f/fa/Flag_of_Botswana.svg",
  },
  {
    name: "Brazil",
    code: "BR",
    file_url: "//upload.wikimedia.org/wikipedia/en/0/05/Flag_of_Brazil.svg",
  },
  {
    name: "British Indian Ocean Territory",
    code: "IO",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/6/65/Flag_of_the_Commissioner_of_the_British_Indian_Ocean_Territory.svg",
  },
  {
    name: "Brunei Darussalam",
    code: "BN",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/9/9c/Flag_of_Brunei.svg",
  },
  {
    name: "Bulgaria",
    code: "BG",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/9/9a/Flag_of_Bulgaria.svg",
  },
  {
    name: "Burkina Faso",
    code: "BF",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/3/31/Flag_of_Burkina_Faso.svg",
  },
  {
    name: "Burundi",
    code: "BI",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/5/50/Flag_of_Burundi.svg",
  },
  {
    name: "Cabo Verde",
    code: "CV",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/3/38/Flag_of_Cape_Verde.svg",
  },
  {
    name: "Cambodia",
    code: "KH",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/8/83/Flag_of_Cambodia.svg",
  },
  {
    name: "Cameroon",
    code: "CM",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/4/4f/Flag_of_Cameroon.svg",
  },
  {
    name: "Canada",
    code: "CA",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/d/d9/Flag_of_Canada_%28Pantone%29.svg",
  },
  {
    name: "Cayman Islands",
    code: "KY",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/0/0f/Flag_of_the_Cayman_Islands.svg",
  },
  {
    name: "Central African Republic",
    code: "CF",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/6/6f/Flag_of_the_Central_African_Republic.svg",
  },
  {
    name: "Chad",
    code: "TD",
    file_url: "//upload.wikimedia.org/wikipedia/commons/4/4b/Flag_of_Chad.svg",
  },
  {
    name: "Chile",
    code: "CL",
    file_url: "//upload.wikimedia.org/wikipedia/commons/7/78/Flag_of_Chile.svg",
  },
  {
    name: "China",
    code: "CN",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/f/fa/Flag_of_the_People%27s_Republic_of_China.svg",
  },
  {
    name: "Christmas Island",
    code: "CX",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/6/67/Flag_of_Christmas_Island.svg",
  },
  {
    name: "Cocos (Keeling) Islands",
    code: "CC",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/7/74/Flag_of_the_Cocos_%28Keeling%29_Islands.svg",
  },
  {
    name: "Colombia",
    code: "CO",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/2/21/Flag_of_Colombia.svg",
  },
  {
    name: "Comoros",
    code: "KM",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/9/94/Flag_of_the_Comoros.svg",
  },
  {
    name: "Congo",
    code: "CG",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/9/92/Flag_of_the_Republic_of_the_Congo.svg",
  },
  {
    name: "Congo - Democratic Republic of the",
    code: "CD",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/6/6f/Flag_of_the_Democratic_Republic_of_the_Congo.svg",
  },
  {
    name: "Cook Islands",
    code: "CK",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/3/35/Flag_of_the_Cook_Islands.svg",
  },
  {
    name: "Costa Rica",
    code: "CR",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/f/f2/Flag_of_Costa_Rica.svg",
  },
  {
    name: "Côte d'Ivoire",
    code: "CI",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/f/fe/Flag_of_C%C3%B4te_d%27Ivoire.svg",
  },
  {
    name: "Croatia",
    code: "HR",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/1/1b/Flag_of_Croatia.svg",
  },
  {
    name: "Cuba",
    code: "CU",
    file_url: "//upload.wikimedia.org/wikipedia/commons/b/bd/Flag_of_Cuba.svg",
  },
  {
    name: "Curaçao",
    code: "CW",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/b/b1/Flag_of_Cura%C3%A7ao.svg",
  },
  {
    name: "Cyprus",
    code: "CY",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/d/d4/Flag_of_Cyprus.svg",
  },
  {
    name: "Czechia",
    code: "CZ",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/c/cb/Flag_of_the_Czech_Republic.svg",
  },
  {
    name: "Denmark",
    code: "DK",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/9/9c/Flag_of_Denmark.svg",
  },
  {
    name: "Djibouti",
    code: "DJ",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/3/34/Flag_of_Djibouti.svg",
  },
  {
    name: "Dominica",
    code: "DM",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/c/c4/Flag_of_Dominica.svg",
  },
  {
    name: "Dominican Republic",
    code: "DO",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/9/9f/Flag_of_the_Dominican_Republic.svg",
  },
  {
    name: "Ecuador",
    code: "EC",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/e/e8/Flag_of_Ecuador.svg",
  },
  {
    name: "Egypt",
    code: "EG",
    file_url: "//upload.wikimedia.org/wikipedia/commons/f/fe/Flag_of_Egypt.svg",
  },
  {
    name: "El Salvador",
    code: "SV",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/3/34/Flag_of_El_Salvador.svg",
  },
  {
    name: "Equatorial Guinea",
    code: "GQ",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/3/31/Flag_of_Equatorial_Guinea.svg",
  },
  {
    name: "Eritrea",
    code: "ER",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/2/29/Flag_of_Eritrea.svg",
  },
  {
    name: "Estonia",
    code: "EE",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/8/8f/Flag_of_Estonia.svg",
  },
  {
    name: "Eswatini",
    code: "SZ",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/f/fb/Flag_of_Eswatini.svg",
  },
  {
    name: "Ethiopia",
    code: "ET",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/7/71/Flag_of_Ethiopia.svg",
  },
  {
    name: "Falkland Islands (Malvinas)",
    code: "FK",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/8/83/Flag_of_the_Falkland_Islands.svg",
  },
  {
    name: "Faroe Islands",
    code: "FO",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/3/3c/Flag_of_the_Faroe_Islands.svg",
  },
  {
    name: "Fiji",
    code: "FJ",
    file_url: "//upload.wikimedia.org/wikipedia/commons/b/ba/Flag_of_Fiji.svg",
  },
  {
    name: "Finland",
    code: "FI",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/b/bc/Flag_of_Finland.svg",
  },
  {
    name: "France",
    code: "FR",
    file_url: "//upload.wikimedia.org/wikipedia/en/c/c3/Flag_of_France.svg",
  },
  {
    name: "French Polynesia",
    code: "PF",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/d/db/Flag_of_French_Polynesia.svg",
  },
  {
    name: "French Southern Territories",
    code: "TF",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/a/a7/Flag_of_the_French_Southern_and_Antarctic_Lands.svg",
  },
  {
    name: "Gabon",
    code: "GA",
    file_url: "//upload.wikimedia.org/wikipedia/commons/0/04/Flag_of_Gabon.svg",
  },
  {
    name: "Gambia",
    code: "GM",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/7/77/Flag_of_The_Gambia.svg",
  },
  {
    name: "Georgia",
    code: "GE",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/0/0f/Flag_of_Georgia.svg",
  },
  {
    name: "Germany",
    code: "DE",
    file_url: "//upload.wikimedia.org/wikipedia/en/b/ba/Flag_of_Germany.svg",
  },
  {
    name: "Ghana",
    code: "GH",
    file_url: "//upload.wikimedia.org/wikipedia/commons/1/19/Flag_of_Ghana.svg",
  },
  {
    name: "Gibraltar",
    code: "GI",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/0/02/Flag_of_Gibraltar.svg",
  },
  {
    name: "Greece",
    code: "GR",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/5/5c/Flag_of_Greece.svg",
  },
  {
    name: "Greenland",
    code: "GL",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/0/09/Flag_of_Greenland.svg",
  },
  {
    name: "Grenada",
    code: "GD",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/b/bc/Flag_of_Grenada.svg",
  },
  {
    name: "Guam",
    code: "GU",
    file_url: "//upload.wikimedia.org/wikipedia/commons/0/07/Flag_of_Guam.svg",
  },
  {
    name: "Guatemala",
    code: "GT",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/e/ec/Flag_of_Guatemala.svg",
  },
  {
    name: "Guernsey",
    code: "GG",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/f/fa/Flag_of_Guernsey.svg",
  },
  {
    name: "Guinea",
    code: "GN",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/e/ed/Flag_of_Guinea.svg",
  },
  {
    name: "Guinea-Bissau",
    code: "GW",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/0/01/Flag_of_Guinea-Bissau.svg",
  },
  {
    name: "Guyana",
    code: "GY",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/9/99/Flag_of_Guyana.svg",
  },
  {
    name: "Haiti",
    code: "HT",
    file_url: "//upload.wikimedia.org/wikipedia/commons/5/56/Flag_of_Haiti.svg",
  },
  {
    name: "Heard Island and McDonald Islands",
    code: "HM",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/b/bb/Proposed_flag_of_Antarctica_%28Graham_Bartram%29.svg",
  },
  {
    name: "Holy See",
    code: "VA",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/0/00/Flag_of_the_Vatican_City.svg",
  },
  {
    name: "Honduras",
    code: "HN",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/8/82/Flag_of_Honduras.svg",
  },
  {
    name: "Hong Kong",
    code: "HK",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/5/5b/Flag_of_Hong_Kong.svg",
  },
  {
    name: "Hungary",
    code: "HU",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/c/c1/Flag_of_Hungary.svg",
  },
  {
    name: "Iceland",
    code: "IS",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/c/ce/Flag_of_Iceland.svg",
  },
  {
    name: "India",
    code: "IN",
    file_url: "//upload.wikimedia.org/wikipedia/en/4/41/Flag_of_India.svg",
  },
  {
    name: "Indonesia",
    code: "ID",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/9/9f/Flag_of_Indonesia.svg",
  },
  {
    name: "Iran (Islamic Republic of)",
    code: "IR",
    file_url: "//upload.wikimedia.org/wikipedia/commons/c/ca/Flag_of_Iran.svg",
  },
  {
    name: "Iraq",
    code: "IQ",
    file_url: "//upload.wikimedia.org/wikipedia/commons/f/f6/Flag_of_Iraq.svg",
  },
  {
    name: "Ireland",
    code: "IE",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/4/45/Flag_of_Ireland.svg",
  },
  {
    name: "Isle of Man",
    code: "IM",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/b/bc/Flag_of_the_Isle_of_Man.svg",
  },
  {
    name: "Israel",
    code: "IL",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/d/d4/Flag_of_Israel.svg",
  },
  {
    name: "Italy",
    code: "IT",
    file_url: "//upload.wikimedia.org/wikipedia/en/0/03/Flag_of_Italy.svg",
  },
  {
    name: "Jamaica",
    code: "JM",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/0/0a/Flag_of_Jamaica.svg",
  },
  {
    name: "Japan",
    code: "JP",
    file_url: "//upload.wikimedia.org/wikipedia/en/9/9e/Flag_of_Japan.svg",
  },
  {
    name: "Jersey",
    code: "JE",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/1/1c/Flag_of_Jersey.svg",
  },
  {
    name: "Jordan",
    code: "JO",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/c/c0/Flag_of_Jordan.svg",
  },
  {
    name: "Kazakhstan",
    code: "KZ",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/d/d3/Flag_of_Kazakhstan.svg",
  },
  {
    name: "Kenya",
    code: "KE",
    file_url: "//upload.wikimedia.org/wikipedia/commons/4/49/Flag_of_Kenya.svg",
  },
  {
    name: "Kiribati",
    code: "KI",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/d/d3/Flag_of_Kiribati.svg",
  },
  {
    name: "Korea (Democratic People's Republic of)",
    code: "KP",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/5/51/Flag_of_North_Korea.svg",
  },
  {
    name: "Korea - Republic of",
    code: "KR",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/0/09/Flag_of_South_Korea.svg",
  },
  {
    name: "Kuwait",
    code: "KW",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/a/aa/Flag_of_Kuwait.svg",
  },
  {
    name: "Kyrgyzstan",
    code: "KG",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/c/c7/Flag_of_Kyrgyzstan.svg",
  },
  {
    name: "Lao People's Democratic Republic",
    code: "LA",
    file_url: "//upload.wikimedia.org/wikipedia/commons/5/56/Flag_of_Laos.svg",
  },
  {
    name: "Latvia",
    code: "LV",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/8/84/Flag_of_Latvia.svg",
  },
  {
    name: "Lebanon",
    code: "LB",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/5/59/Flag_of_Lebanon.svg",
  },
  {
    name: "Lesotho",
    code: "LS",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/4/4a/Flag_of_Lesotho.svg",
  },
  {
    name: "Liberia",
    code: "LR",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/b/b8/Flag_of_Liberia.svg",
  },
  {
    name: "Libya",
    code: "LY",
    file_url: "//upload.wikimedia.org/wikipedia/commons/0/05/Flag_of_Libya.svg",
  },
  {
    name: "Liechtenstein",
    code: "LI",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/4/47/Flag_of_Liechtenstein.svg",
  },
  {
    name: "Lithuania",
    code: "LT",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/1/11/Flag_of_Lithuania.svg",
  },
  {
    name: "Luxembourg",
    code: "LU",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/d/da/Flag_of_Luxembourg.svg",
  },
  {
    name: "Macao",
    code: "MO",
    file_url: "//upload.wikimedia.org/wikipedia/commons/6/63/Flag_of_Macau.svg",
  },
  {
    name: "Macedonia (the former Yugoslav Republic of)",
    code: "MK",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/f/f8/Flag_of_North_Macedonia.svg",
  },
  {
    name: "Madagascar",
    code: "MG",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/b/bc/Flag_of_Madagascar.svg",
  },
  {
    name: "Malawi",
    code: "MW",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/d/d1/Flag_of_Malawi.svg",
  },
  {
    name: "Malaysia",
    code: "MY",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/6/66/Flag_of_Malaysia.svg",
  },
  {
    name: "Maldives",
    code: "MV",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/0/0f/Flag_of_Maldives.svg",
  },
  {
    name: "Mali",
    code: "ML",
    file_url: "//upload.wikimedia.org/wikipedia/commons/9/92/Flag_of_Mali.svg",
  },
  {
    name: "Malta",
    code: "MT",
    file_url: "//upload.wikimedia.org/wikipedia/commons/7/73/Flag_of_Malta.svg",
  },
  {
    name: "Marshall Islands",
    code: "MH",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/2/2e/Flag_of_the_Marshall_Islands.svg",
  },
  {
    name: "Martinique",
    code: "MQ",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/5/52/Flag_of_Martinique.svg",
  },
  {
    name: "Mauritania",
    code: "MR",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/4/43/Flag_of_Mauritania.svg",
  },
  {
    name: "Mauritius",
    code: "MU",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/7/77/Flag_of_Mauritius.svg",
  },
  {
    name: "Mayotte",
    code: "YT",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/c/c3/Flag_of_Mayotte.svg",
  },
  {
    name: "Mexico",
    code: "MX",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/f/fc/Flag_of_Mexico.svg",
  },
  {
    name: "Micronesia (Federated States of)",
    code: "FM",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/e/e4/Flag_of_the_Federated_States_of_Micronesia.svg",
  },
  {
    name: "Moldova - Republic of",
    code: "MD",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/2/27/Flag_of_Moldova.svg",
  },
  {
    name: "Monaco",
    code: "MC",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/e/ea/Flag_of_Monaco.svg",
  },
  {
    name: "Mongolia",
    code: "MN",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/4/4c/Flag_of_Mongolia.svg",
  },
  {
    name: "Montenegro",
    code: "ME",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/6/64/Flag_of_Montenegro.svg",
  },
  {
    name: "Montserrat",
    code: "MS",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/d/d0/Flag_of_Montserrat.svg",
  },
  {
    name: "Morocco",
    code: "MA",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/2/2c/Flag_of_Morocco.svg",
  },
  {
    name: "Mozambique",
    code: "MZ",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/d/d0/Flag_of_Mozambique.svg",
  },
  {
    name: "Myanmar",
    code: "MM",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/8/8c/Flag_of_Myanmar.svg",
  },
  {
    name: "Namibia",
    code: "NA",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/0/00/Flag_of_Namibia.svg",
  },
  {
    name: "Nauru",
    code: "NR",
    file_url: "//upload.wikimedia.org/wikipedia/commons/3/30/Flag_of_Nauru.svg",
  },
  {
    name: "Nepal",
    code: "NP",
    file_url: "//upload.wikimedia.org/wikipedia/commons/9/9b/Flag_of_Nepal.svg",
  },
  {
    name: "Netherlands",
    code: "NL",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/2/20/Flag_of_the_Netherlands.svg",
  },
  {
    name: "New Caledonia",
    code: "NC",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/2/23/Flag_of_New_Caledonia.svg",
  },
  {
    name: "New Zealand",
    code: "NZ",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/3/3e/Flag_of_New_Zealand.svg",
  },
  {
    name: "Nicaragua",
    code: "NI",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/1/19/Flag_of_Nicaragua.svg",
  },
  {
    name: "Niger",
    code: "NE",
    file_url: "//upload.wikimedia.org/wikipedia/commons/f/f4/Flag_of_Niger.svg",
  },
  {
    name: "Nigeria",
    code: "NG",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/7/79/Flag_of_Nigeria.svg",
  },
  {
    name: "Niue",
    code: "NU",
    file_url: "//upload.wikimedia.org/wikipedia/commons/0/01/Flag_of_Niue.svg",
  },
  {
    name: "Norfolk Island",
    code: "NF",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/4/48/Flag_of_Norfolk_Island.svg",
  },
  {
    name: "North Macedonia",
    code: "MK",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/7/79/Flag_of_North_Macedonia.svg",
  },
  {
    name: "Northern Mariana Islands",
    code: "MP",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/e/e0/Flag_of_the_Northern_Mariana_Islands.svg",
  },
  {
    name: "Norway",
    code: "NO",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/d/d9/Flag_of_Norway.svg",
  },
  {
    name: "Oman",
    code: "OM",
    file_url: "//upload.wikimedia.org/wikipedia/commons/d/dd/Flag_of_Oman.svg",
  },
  {
    name: "Pakistan",
    code: "PK",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/3/32/Flag_of_Pakistan.svg",
  },
  {
    name: "Palau",
    code: "PW",
    file_url: "//upload.wikimedia.org/wikipedia/commons/4/48/Flag_of_Palau.svg",
  },
  {
    name: "Palestine - State of",
    code: "PS",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/0/00/Flag_of_Palestine.svg",
  },
  {
    name: "Panama",
    code: "PA",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/a/ab/Flag_of_Panama.svg",
  },
  {
    name: "Papua New Guinea",
    code: "PG",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/e/e3/Flag_of_Papua_New_Guinea.svg",
  },
  {
    name: "Paraguay",
    code: "PY",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/2/27/Flag_of_Paraguay.svg",
  },
  {
    name: "Peru",
    code: "PE",
    file_url: "//upload.wikimedia.org/wikipedia/commons/c/cf/Flag_of_Peru.svg",
  },
  {
    name: "Philippines",
    code: "PH",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/9/99/Flag_of_the_Philippines.svg",
  },
  {
    name: "Pitcairn",
    code: "PN",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/8/88/Flag_of_the_Pitcairn_Islands.svg",
  },
  {
    name: "Poland",
    code: "PL",
    file_url: "//upload.wikimedia.org/wikipedia/en/1/12/Flag_of_Poland.svg",
  },
  {
    name: "Portugal",
    code: "PT",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/5/5c/Flag_of_Portugal.svg",
  },
  {
    name: "Puerto Rico",
    code: "PR",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/2/28/Flag_of_Puerto_Rico.svg",
  },
  {
    name: "Qatar",
    code: "QA",
    file_url: "//upload.wikimedia.org/wikipedia/commons/6/65/Flag_of_Qatar.svg",
  },
  {
    name: "Romania",
    code: "RO",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/7/73/Flag_of_Romania.svg",
  },
  {
    name: "Russian Federation",
    code: "RU",
    file_url: "//upload.wikimedia.org/wikipedia/en/f/f3/Flag_of_Russia.svg",
  },
  {
    name: "Rwanda",
    code: "RW",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/1/17/Flag_of_Rwanda.svg",
  },
  {
    name: "Saint Barthélemy",
    code: "BL",
    file_url: "//upload.wikimedia.org/wikipedia/en/c/c3/Flag_of_France.svg",
  },
  {
    name: "Saint Helena - Ascension and Tristan da Cunha",
    code: "SH",
    file_url:
      "//upload.wikimedia.org/wikipedia/en/a/ae/Flag_of_the_United_Kingdom.svg",
  },
  {
    name: "Saint Kitts and Nevis",
    code: "KN",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/f/fe/Flag_of_Saint_Kitts_and_Nevis.svg",
  },
  {
    name: "Saint Lucia",
    code: "LC",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/9/9f/Flag_of_Saint_Lucia.svg",
  },
  {
    name: "Saint Martin (French part)",
    code: "MF",
    file_url: "//upload.wikimedia.org/wikipedia/en/c/c3/Flag_of_France.svg",
  },
  {
    name: "Saint Vincent and the Grenadines",
    code: "VC",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/6/6d/Flag_of_Saint_Vincent_and_the_Grenadines.svg",
  },
  {
    name: "Samoa",
    code: "WS",
    file_url: "//upload.wikimedia.org/wikipedia/commons/3/31/Flag_of_Samoa.svg",
  },
  {
    name: "San Marino",
    code: "SM",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/b/b1/Flag_of_San_Marino.svg",
  },
  {
    name: "Sao Tome and Principe",
    code: "ST",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/4/4f/Flag_of_Sao_Tome_and_Principe.svg",
  },
  {
    name: "Saudi Arabia",
    code: "SA",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/0/0d/Flag_of_Saudi_Arabia.svg",
  },
  {
    name: "Senegal",
    code: "SN",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/f/fd/Flag_of_Senegal.svg",
  },
  {
    name: "Serbia",
    code: "RS",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/f/ff/Flag_of_Serbia.svg",
  },
  {
    name: "Seychelles",
    code: "SC",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/f/fc/Flag_of_Seychelles.svg",
  },
  {
    name: "Sierra Leone",
    code: "SL",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/1/17/Flag_of_Sierra_Leone.svg",
  },
  {
    name: "Singapore",
    code: "SG",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/4/48/Flag_of_Singapore.svg",
  },
  {
    name: "Sint Maarten (Dutch part)",
    code: "SX",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/d/d3/Flag_of_Sint_Maarten.svg",
  },
  {
    name: "Slovakia",
    code: "SK",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/e/e6/Flag_of_Slovakia.svg",
  },
  {
    name: "Slovenia",
    code: "SI",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/f/f0/Flag_of_Slovenia.svg",
  },
  {
    name: "Solomon Islands",
    code: "SB",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/7/74/Flag_of_the_Solomon_Islands.svg",
  },
  {
    name: "Somalia",
    code: "SO",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/a/a0/Flag_of_Somalia.svg",
  },
  {
    name: "South Africa",
    code: "ZA",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/a/af/Flag_of_South_Africa.svg",
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    code: "GS",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/e/ed/Flag_of_South_Georgia_and_the_South_Sandwich_Islands.svg",
  },
  {
    name: "South Sudan",
    code: "SS",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/7/7a/Flag_of_South_Sudan.svg",
  },
  {
    name: "Spain",
    code: "ES",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/8/89/Bandera_de_Espa%C3%B1a.svg",
  },
  {
    name: "Sri Lanka",
    code: "LK",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/1/11/Flag_of_Sri_Lanka.svg",
  },
  {
    name: "Sudan",
    code: "SD",
    file_url: "//upload.wikimedia.org/wikipedia/commons/0/01/Flag_of_Sudan.svg",
  },
  {
    name: "Suriname",
    code: "SR",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/6/60/Flag_of_Suriname.svg",
  },
  {
    name: "Svalbard and Jan Mayen",
    code: "SJ",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/d/d9/Flag_of_Norway.svg",
  },
  {
    name: "Sweden",
    code: "SE",
    file_url: "//upload.wikimedia.org/wikipedia/en/4/4c/Flag_of_Sweden.svg",
  },
  {
    name: "Switzerland",
    code: "CH",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/f/f3/Flag_of_Switzerland.svg",
  },
  {
    name: "Syrian Arab Republic",
    code: "SY",
    file_url: "//upload.wikimedia.org/wikipedia/commons/5/53/Flag_of_Syria.svg",
  },
  {
    name: "Tajikistan",
    code: "TJ",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/d/d0/Flag_of_Tajikistan.svg",
  },
  {
    name: "Tanzania - United Republic of",
    code: "TZ",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/3/38/Flag_of_Tanzania.svg",
  },
  {
    name: "Thailand",
    code: "TH",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/a/a9/Flag_of_Thailand.svg",
  },
  {
    name: "Timor-Leste",
    code: "TL",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/2/26/Flag_of_East_Timor.svg",
  },
  {
    name: "Togo",
    code: "TG",
    file_url: "//upload.wikimedia.org/wikipedia/commons/6/68/Flag_of_Togo.svg",
  },
  {
    name: "Tokelau",
    code: "TK",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/8/8e/Flag_of_Tokelau.svg",
  },
  {
    name: "Tonga",
    code: "TO",
    file_url: "//upload.wikimedia.org/wikipedia/commons/9/9a/Flag_of_Tonga.svg",
  },
  {
    name: "Trinidad and Tobago",
    code: "TT",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/6/64/Flag_of_Trinidad_and_Tobago.svg",
  },
  {
    name: "Tunisia",
    code: "TN",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/c/ce/Flag_of_Tunisia.svg",
  },
  {
    name: "Turkiye",
    code: "TR",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/b/b4/Flag_of_Turkey.svg",
  },
  {
    name: "Turkmenistan",
    code: "TM",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/1/1b/Flag_of_Turkmenistan.svg",
  },
  {
    name: "Turks and Caicos Islands",
    code: "TC",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/a/a0/Flag_of_the_Turks_and_Caicos_Islands.svg",
  },
  {
    name: "Tuvalu",
    code: "TV",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/3/38/Flag_of_Tuvalu.svg",
  },
  {
    name: "Uganda",
    code: "UG",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/4/4e/Flag_of_Uganda.svg",
  },
  {
    name: "Ukraine",
    code: "UA",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/4/49/Flag_of_Ukraine.svg",
  },
  {
    name: "United Arab Emirates",
    code: "AE",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/c/cb/Flag_of_the_United_Arab_Emirates.svg",
  },
  {
    name: "United Kingdom of Great Britain and Northern Ireland",
    code: "GB",
    file_url:
      "//upload.wikimedia.org/wikipedia/en/a/ae/Flag_of_the_United_Kingdom.svg",
  },
  {
    name: "United States of America",
    code: "US",
    file_url:
      "//upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg",
  },
  {
    name: "United States Minor Outlying Islands",
    code: "UM",
    file_url:
      "//upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg",
  },
  {
    name: "Uruguay",
    code: "UY",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/f/fe/Flag_of_Uruguay.svg",
  },
  {
    name: "Uzbekistan",
    code: "UZ",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/8/84/Flag_of_Uzbekistan.svg",
  },
  {
    name: "Vanuatu",
    code: "VU",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/6/6e/Flag_of_Vanuatu_%28official%29.svg",
  },
  {
    name: "Venezuela (Bolivarian Republic of)",
    code: "VE",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/0/06/Flag_of_Venezuela.svg",
  },
  {
    name: "Viet Nam",
    code: "VN",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/2/21/Flag_of_Vietnam.svg",
  },
  {
    name: "Virgin Islands (British)",
    code: "VG",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/4/42/Flag_of_the_British_Virgin_Islands.svg",
  },
  {
    name: "Virgin Islands (U.S.)",
    code: "VI",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/f/f8/Flag_of_the_United_States_Virgin_Islands.svg",
  },
  {
    name: "Wallis and Futuna",
    code: "WF",
    file_url: "//upload.wikimedia.org/wikipedia/en/c/c3/Flag_of_France.svg",
  },
  {
    name: "Yemen",
    code: "YE",
    file_url: "//upload.wikimedia.org/wikipedia/commons/8/89/Flag_of_Yemen.svg",
  },
  {
    name: "Zambia",
    code: "ZM",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/0/06/Flag_of_Zambia.svg",
  },
  {
    name: "Zimbabwe",
    code: "ZW",
    file_url:
      "//upload.wikimedia.org/wikipedia/commons/6/6a/Flag_of_Zimbabwe.svg",
  },
];
